import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { CustomerLayout } from "@/components/CustomerLayout";
import { OrderTicket } from "@/components/OrderTicket";
import { Timeline } from "@/pages/OrderConfirmation";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function TrackOrder() {
  const [num, setNum] = useState("");
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const track = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true); setOrder(null);
    try {
      const { data } = await api.get(`/orders/track/${num.trim()}`);
      setOrder(data);
    } catch (e2) { setErr(formatApiErrorDetail(e2.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <CustomerLayout>
      <div className="max-w-2xl mx-auto px-4 py-8">
        <h1 className="font-display text-3xl font-bold mb-2">Track Your Order</h1>
        <p className="text-muted-foreground mb-6">Enter your order number (e.g. AS-CR-20260920-0001).</p>
        <form onSubmit={track} className="flex gap-2 mb-6">
          <Input value={num} onChange={(e) => setNum(e.target.value)} placeholder="AS-CR-..." className="h-12" data-testid="track-input" />
          <Button type="submit" disabled={busy} className="h-12 bg-[#1B5E20] hover:bg-[#144718]" data-testid="track-submit"><Search size={18} /></Button>
        </form>
        {err && <div className="bg-red-50 text-[#C62828] text-sm rounded-lg p-3" data-testid="track-error">{err}</div>}
        {order && <div className="space-y-4"><OrderTicket order={order} /><Timeline order={order} /></div>}
      </div>
    </CustomerLayout>
  );
}
